import { Component, effect, inject, input, signal } from '@angular/core';

import { RegisterComponent } from '../component-lookup';
import { GlobalConstants } from '../../../shared/global-constants';
import { StateService } from '../../services/state.service';
import { Metric, MetricService } from '../../services/metric.service';
import { VisualService } from '../../services/visual.service';

@RegisterComponent('PerformanceLegend')
@Component({
  selector: 'app-performance-legend',
  standalone: true,
  imports: [],
  templateUrl: './performance-legend.component.html',
  styleUrl: './performance-legend.component.scss'
})
export class PerformanceLegendComponent {
  roomName = input.required<string>();
  metricId = input.required<string>();

  metric = signal<Metric>({} as Metric);
  institutionValue = signal<number | null>(null);
  peerValue = signal<number | null>(null);

  private metricService = inject(MetricService);
  private visualService = inject(VisualService);
  private stateService = inject(StateService);
  readonly institution = this.stateService.institution;
  readonly peer = this.stateService.peer;
  readonly filteredGroup = inject(StateService).filteredGroup;
  readonly dateRange = this.stateService.dateRange;
  readonly rate = this.stateService.rate;
  readonly peerName = this.stateService.peerName;

  public institutionColor = GlobalConstants.colors[0];
  public peerColor = GlobalConstants.colors[1];
  public rateColor = GlobalConstants.rateColor;
  
  constructor() {
    effect(() => {
      const institution = this.institution();
      const metricId = this.metricId();
      if (institution.iid && metricId) {
        this.metricService.getMetric(this.institution().iid, this.metricId())?.subscribe(metric => {
          setTimeout(() => {
            this.metric.set(metric);
          });
        });
      }
    });

    effect(() => {
      const peer = this.peer();
      const dateRange = this.dateRange();
      const metricId = this.metricId();
      const group = this.filteredGroup();
      if (peer && dateRange && metricId && group) {
        this.metricService.getMetricData(this.institution().iid, metricId, peer)?.subscribe(data => {
          const dataValues = this.visualService.getMetricValuesPeer(this.metric().displayType, data, dateRange.endDate);
          setTimeout(() => {
            this.institutionValue.set(dataValues.institutionValue);
            this.peerValue.set(dataValues.peerValue ? Math.round(dataValues.peerValue) : null);
          });
        });
      }
    });
  }
}
